import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubscriptionLike} from 'rxjs';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {CarTarjeta} from '../../../modelo/soporte/car-tarjeta';
import {CarTarjetaService} from '../../../servicios/soporte/car-tarjeta.service';

@Component({
  selector: 'app-tarjeta-carrusel',
  templateUrl: './tarjeta-carrusel.component.html',
  styleUrls: ['./tarjeta-carrusel.component.css']
})
export class TarjetaCarruselComponent implements OnInit, OnDestroy {
  private subs:SubscriptionLike[];
  public optionsDefault:OwlOptions;
  public carTarjeta:CarTarjeta[];

  constructor(private carTarjSV:CarTarjetaService) {
    this.subs=[];
    this.carTarjeta=[];
    this.optionsDefault={
      items:1,
      loop:true,
      mouseDrag:true,
      touchDrag:false,
      pullDrag:false,
      navSpeed:700,
      navText:[],
      nav:false,
      rewind:true,
      dots:false,
      autoplay:true,
      autoplayTimeout:5000,
      smartSpeed:500,
      autoWidth: true
    }
  }

  ngOnInit(): void {
    this.subs.push(
      this.carTarjSV.listarCarTarjetaHab().subscribe(res=>{
        this.carTarjeta=res.data;
      })
    )
  }
  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }


}
